module.exports = __webpack_public_path__ + "img/icon-check.ad4cb25a.svg";